import { InjectionToken } from "@angular/core";
import * as Rollbar from "rollbar";

export const ROLLBAR_CONFIG_TOKEN = new InjectionToken<Rollbar>('rollbar');
